export const IMAGE_SIZE_ERROR_MESSAGE = "Images size exceeds the limit.";

export const isImageSizeError = (error) =>
    error.errorCode === 12 || error.status === 413;
